import React from "react";
import { Calendar } from 'primereact/calendar';
import "primeflex/primeflex.css";
import useFormError from "../../hooks/useFormError";

const ProCalendar = ({id, value, onChange, headerText, style, placeholder, formik = {}, error,
               required, disabled=false, minDate=null, maxDate=null, showTime = false})=>{

    const getFormErrorMessage = useFormError(formik);
    const placeholderText = required?<label htmlFor="dropdown">{placeholder}</label>: <label htmlFor="inputtext" >{placeholder}<span style={{fontSize:11}}>  (optional)</span></label>
   
    return (
        <div>
      <div className="p-field p-col-12 p-md-12">
      {
        headerText && 
        <div className="p-d-flex p-jc-start">
        <h6 className="form-header">{headerText}</h6>
      </div>
      }
      <span className={disabled?"p-float-label p-disabled": "p-float-label"}>
        <Calendar style={{ ...style }}
          id={id}
          value={value}
          onChange={onChange} 
          minDate = {minDate} 
          maxDate={maxDate}        
          showIcon 
          showTime ={showTime}
          selectOtherMonths       
        />       
        {placeholderText}
      </span>     
    </div>
    <div>
      {getFormErrorMessage && getFormErrorMessage(error)}
      </div>
    </div>
    )

}

export default ProCalendar;